import React, { FC } from 'react';
import CheckboxListWithSearch from '@minecraft.checkbox-list-with-search';
import { useDrawerSearchFilterNameOrCategory } from '@minecraft.drawer';
import { FilterData } from '../../../shared/types';
import { Label } from '../../../shared/styles';
import { FiltersCategoryNameEnum } from '../../shared/types';

type Props = FilterData;

const EyeColor: FC<Props> = ({ name, label }) => {
  const { isSearching, getMatchedSearchOptions } = useDrawerSearchFilterNameOrCategory(
    FiltersCategoryNameEnum.eyeColor
  );

  return (
    <>
      {isSearching && <Label>{label}</Label>}
      <CheckboxListWithSearch withFormik withSelectAll name={name} options={getMatchedSearchOptions(name)} />
    </>
  );
};

export default EyeColor;
